import { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router';
import { captureAffiliateRef } from '@/features/affiliate/referralAttribution';
import { setPendingCoupon } from '@/features/affiliate/pendingCoupon';
import { recordDemoAffiliateClick } from '@/pages/admin/demo/store/adminDemoStore';

/**
 * Reads `?ref=` / `?coupon=` on public URLs.
 * Skips staff panels so affiliates browsing their own dashboard don't self-tag.
 */
export function AffiliateRefCapture() {
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (
      pathname.startsWith('/admin') ||
      pathname.startsWith('/instructor') ||
      pathname.startsWith('/partner')
    ) {
      return;
    }
    const rawRef = searchParams.get('ref');
    if (rawRef) {
      const captured = captureAffiliateRef(rawRef, pathname);
      if (captured?.isNewClick) recordDemoAffiliateClick(captured.code);
    }
    const rawCoupon = searchParams.get('coupon');
    if (rawCoupon) setPendingCoupon(rawCoupon);
  }, [pathname, searchParams]);

  return null;
}
